import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfGraficas } from '@/modules/Configuracion/interfaces'
import type { IGraficaItem } from '../interfaces'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
export class HistoriaGraficaService extends BaseService<IConfGraficas> {
  constructor () {
    super({
      baseUrl: 'system/graphics-histories/'
    })
  }
  async getBase64Graphics (params: IGraficaItem[]): Promise<AxiosResponse<IResponseApi<IGraficaItem[]>>> {
    return this.http.post<IResponseApi<IGraficaItem[]>>( `/get-base64-graphics`, params).catch(error => this.errorHandle(error))
  }
}
